"use client"

import { cn } from "@/lib/utils"
import { Loader2 } from "lucide-react"

interface LoadingSpinnerProps {
    /** Size of the spinner */
    size?: "sm" | "md" | "lg"
    /** Optional text to display below the spinner */
    text?: string
    /** Optional subtext for additional context */
    subtext?: string
    /** Additional CSS classes */
    className?: string
    /** Use full height container */
    fullHeight?: boolean
}

const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
} as const

export function LoadingSpinner({
    size = "md",
    text,
    subtext,
    className,
    fullHeight = false,
}: LoadingSpinnerProps) {
    return (
        <div
            className={cn(
                "flex flex-col items-center justify-center",
                fullHeight && "min-h-[400px]",
                className
            )}
        >
            <Loader2
                className={cn(
                    "animate-spin text-primary",
                    sizeClasses[size]
                )}
            />
            {text && (
                <p className="mt-4 text-lg font-medium text-foreground">{text}</p>
            )}
            {subtext && (
                <p className="mt-2 text-sm text-muted-foreground">{subtext}</p>
            )}
        </div>
    )
}

/**
 * Simple inline spinner for buttons or small areas
 */
export function InlineSpinner({ className }: { className?: string }) {
    return (
        <div
            className={cn(
                "w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin",
                className
            )}
        />
    )
}

export default LoadingSpinner
